const TEMPLATE_NAME = 'PAD_MONITORING_PRESCRIPTION';

const initialState = () => ({
  loading: false,
  filter: {
    term: '',
    matMed: []
  }
});

const reducer = (state = initialState(), action) => {
  switch (action.type) {
    case `${TEMPLATE_NAME}_PENDING`: {
      return {
        ...state,
        loading: true
      };
    }
    case `${TEMPLATE_NAME}_REJECTED`: {
      return {
        ...state,
        loading: false
      };
    }
    case `${TEMPLATE_NAME}_FULFILLED`: {
      const newData = action.payload;

      return {
        ...state,
        loading: false,
        filter: {
          ...state.filter,
          matMed: newData
        }
      };
    }

    case `${TEMPLATE_NAME}_RESET`: {
      return initialState();
    }
    default:
      return state;
  }
};
export default reducer;
